import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { ChooseIconComponent } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'atw-check-box-choose-product-config',
  templateUrl: './check-box-choose-product-config.component.html',
  styleUrls: ['./check-box-choose-product-config.component.scss']
})
export class AtwCheckBoxChooseProductConfig implements OnInit {
  isCollapsed: boolean = false; // check hiển thị ở config menu
  @Input() config: any = {}; // là desktop_config hoặc mobile_config
  @Input() class: any;  // là desktop_class hoặc mobile class
  @Input() objectChoosing: any; // xác định object hiệu ứng đang chọn để cấu hình
  @Input() staticdata: any;  // biến lưu staticdata trong json.
  @Input() type_config: string;
  @Input() type: string;
  @Input() device: any; // xác định thiết bị 
  @Output() closeConfigTool = new EventEmitter();
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  @Output() iconSelected = new EventEmitter<any>();
  isViewAll = false; // biến check để mở thêm các confg ở phần mở rộng 
  fonts = [];  // biến lưu danh sách các fonts chữ 
  currentViewAll = { title: '', index: 0 };
  arr_link_page: any; // danh sách các link của page 
  id_subproject: any;
  dataAfterChange: any = {};
  width = 0;
  height = 0;
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];
  link_type: any = [
    {
      name: 'Mở trong trang mới',
      value: '_blank'
    },
    {
      name: 'Mở trong trang hiện tại',
      value: '_self'
    }
  ]

  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`
  };
  parserDeg = (value: string): string => value.replace('°', '');
  formatterDeg = (value: number): string => {
    return `${value} °`
  };

  constructor(private dialog: MatDialog, public vhQueryAutoWeb: VhQueryAutoWeb, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {


  }

  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([background_colors, fonts]: any) => {
      this.fonts = fonts;
    });

    if (!this.config.disabled) {
      this.config.disabled = {
        is_show: false,
        'opacity': 1,
        'background-color': '',
        'border-color': ''
      };
    }
  }


  /**
   * hủy các sự kiện không cân thiết, cập nhật lại config .
   */
  ngOnDestroy(): void {
    this.updateConfig();
  }

  /**
   * Hàm thay đổi cấu hình đổ bóng
   */
  onChangeShadow() {
    if (this.config['box-shadow']['shadow_check'] === false) {
      this.config['box-shadow']['offset_x'] = 0;
      this.config['box-shadow']['offset_y'] = 0;
      this.config['box-shadow']['blur_radius'] = 0;
      this.config['box-shadow']['shadow_color'] = '#333';
    }
    this.class['checkbox__around']['box-shadow'] = `${this.config['box-shadow']['offset_x']}px ${this.config['box-shadow']['offset_y']}px ${this.config['box-shadow']['blur_radius']}px ${this.config['box-shadow']['shadow_color']}`;
  }
  /**
  *Hàm update class vào database, và gửi cập nhật width, height cho object-selected
  */
  updateClassAndWidthHeight() {
    if (isPlatformBrowser(this.platformId)) {
      this.width = document.getElementById(this.objectChoosing._id).clientWidth;
      this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
      this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
        .then((bool: any) => {

        })
    }
  }
  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      })
  }
  /**
 *Hàm update class vào database.
 */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })
  }
  /**
 *Hàm update config vào database.
 */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      })
  }
  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {

      });
  }

  openViewAll(field) {
    this.currentViewAll = field;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false, menu7: false, menu8: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  // update trường mobile_portrait_hidden or desktop_hidden cho object
  updateHidden(value) {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, value).then(
      (bool) => {

      },
      (error) => {
        console.error(error);
      }
    );
  }
  /**
  * Hàm mở ra hộp thoại chọn icon
  */
  openDialogChooseIcon() {
    this.visible_config_tool = false;
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '90vw',
      height: '100vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.staticdata.icon_name = result.icon;
        this.updateStaticData()
      }
      this.visible_config_tool = true;
    });
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width height của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['checkbox']['width'] = event.width + 'px';
    if (event.height) this.class['checkbox']['height'] = event.height + 'px';
    this.updateClassAndWidthHeight();
    this.updateClass();
  }
  /**
   * Hàm này cập nhật giá trị border.
   * @param value 
   * @param typeBorder 
   */
  updateBorder(value: any, typeBorder) {
    if (typeBorder == 'top-left') {
      this.class['checkbox__unselected']['border-top-left-radius'] = value + 'px';
    }
    else if (typeBorder == 'top-right') {
      this.class['checkbox__unselected']['border-top-right-radius'] = value + 'px';
    }
    else if (typeBorder == 'bottom-left') {
      this.class['checkbox__unselected']['border-bottom-left-radius'] = value + 'px';
    }
    else if (typeBorder == 'bottom-right') {
      this.class['checkbox__unselected']['border-bottom-right-radius'] = value + 'px';
    }
    this.updateClass();
  }
  /**
   * Hàm set lại vị tri checkmark , có thêm biến check_mark_positionY và check_mark_positionX để lưu lại vị trí
   * @param value giá trị cập nhật
   * @param position vị trí tương ứng horizontal : ngang; vertical : dọc
   */
  onChangePositionCheckmark(value: any, position: string) {
    if (position == 'horizontal') {
      this.staticdata['check_mark_positionX'] = value;
      this.class['checkbox__selected--icon']['transform'] = `translate(-${value}%, -${this.staticdata['check_mark_positionY']}%)`;
    }
    else if (position == 'vertical') {
      this.staticdata['check_mark_positionY'] = value;
      this.class['checkbox__selected--icon']['transform'] = `translate(-${this.staticdata['check_mark_positionX']}%, -${value}%)`;
    }
    this.updateStaticData();
    this.updateClass();
  }
}

